import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../context/I18nContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Welcome!");
      navigate("/");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-20" data-testid="register-page">
      <h1 className="font-display font-black text-3xl tracking-tighter">{t("auth.registerTitle")}</h1>
      <form onSubmit={onSubmit} className="mt-8 space-y-5">
        <Field label={t("auth.name")} value={form.name} onChange={(v) => setForm({ ...form, name: v })} testid="reg-name" />
        <Field label={t("auth.email")} type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} testid="reg-email" />
        <Field label={t("auth.phone")} value={form.phone} onChange={(v) => setForm({ ...form, phone: v })} testid="reg-phone" />
        <Field label={t("auth.password")} type="password" value={form.password} onChange={(v) => setForm({ ...form, password: v })} testid="reg-password" />
        <button type="submit" disabled={loading} className="btn-maroon w-full py-3 font-bold disabled:opacity-60" data-testid="reg-submit">
          {loading ? t("checkout.processing") : t("auth.submit")}
        </button>
      </form>
      <div className="text-sm text-slate-500 mt-6">
        {t("auth.haveAccount")}{" "}
        <Link to="/login" className="font-bold text-[#8D1B3D] hover:underline" data-testid="goto-login">
          {t("auth.signinCta")}
        </Link>
      </div>
    </div>
  );
}

function Field({ label, type = "text", value, onChange, testid }) {
  return (
    <label className="block">
      <div className="label-mono text-slate-500 mb-1.5">{label}</div>
      <input
        type={type}
        required={type !== "tel" && label !== "Phone" && label !== "الهاتف"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full border border-slate-300 px-3 py-3 outline-none focus:border-[#8D1B3D] text-sm"
        data-testid={testid}
      />
    </label>
  );
}
